import {consoleError} from "@pg-mono/logger";

export const getRelatedPhraseRegex = (phrase: string): RegExp | null => {
    const escapedPhrase = phrase
        .split(" ") // divide into separate words
        .filter((x) => x) // remove empty words
        .map((word) => word.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")) // escape special characters
        // add word boundary
        .map((word, i) => {
            // handle `non-word characters` that appear on end of "word", like special characters and diacritics
            // use `\b` word boundary for normal words like "dom"
            // use non-word boundary `\B` for "też" "zapaść" "mieszkania," "śmieci"
            const isFirstCharNonWord = word[0].match(/\W/i);
            const leftWordBoundary = i === 0 ? "" : isFirstCharNonWord ? "\\B" : "\\b";
            const isLastCharNonWord = word[word.length - 1].match(/\W/i);

            return isLastCharNonWord ? `${leftWordBoundary}${word}\\B` : `${leftWordBoundary}${word}\\b`;
        })
        .join("[\\':;\\-!_.,\\?\\\"\\(\\)\\s]*?"); // allow punctuation marks between words

    let regPhrase = null;

    try {
        regPhrase = new RegExp(escapedPhrase, "i");
    } catch (error) {
        consoleError(`renderLinkInText - problem with phrase: ${phrase}`, error);
    }

    return regPhrase;
};
import {consoleError} from "@pg-mono/logger";

export const getRelatedPhraseRegex = (phrase: string): RegExp | null => {
    const escapedPhrase = phrase
        .split(" ") // divide into separate words
        .filter((x) => x) // remove empty words
        .map((word) => word.replace(/[-[\]{}()*+?.,\\^$|#\s]/g, "\\$&")) // escape special characters
        // add word boundary
        .map((word, i) => {
            // handle `non-word characters` that appear on end of "word", like special characters and diacritics
            // use `\b` word boundary for normal words like "dom"
            // use non-word boundary `\B` for "też" "zapaść" "mieszkania," "śmieci"
            const isFirstCharNonWord = word[0].match(/\W/i);
            const leftWordBoundary = i === 0 ? "" : isFirstCharNonWord ? "\\B" : "\\b";
            const isLastCharNonWord = word[word.length - 1].match(/\W/i);

            return isLastCharNonWord ? `${leftWordBoundary}${word}\\B` : `${leftWordBoundary}${word}\\b`;
        })
        .join("[\\':;\\-!_.,\\?\\\"\\(\\)\\s]*?"); // allow punctuation marks between words

    let regPhrase = null;

    try {
        regPhrase = new RegExp(escapedPhrase, "i");
    } catch (error) {
        consoleError(`renderLinkInText - problem with phrase: ${phrase}`, error);
    }

    return regPhrase;
};
